// extracted by mini-css-extract-plugin
export var boxAdvantages = "advantages-module--box-advantages--tCmxa";
export var titleAdvantages = "advantages-module--title-advantages--M2OOY";
export var subTitle = "advantages-module--sub-title--5b5dI";